(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["media_block"] && !Shopify.designMode) return;
  try {
    $(document).ready(function () {
    // Modal logic only bound once for media block images
    if (!window.mediaBlockModalBound) {
      $(document).on('click', '.media-block .image-wrapper', function () {
        var $block = $(this).closest('.media-block');
        var openModal = $block.data('open-modal');
        if (!openModal || openModal === 'false') return;
        var $imageWrapper = $(this);
        var $originalImage = $imageWrapper.find('img').first();
        var $modalImage = $originalImage.clone().removeClass('aspect-[24/10], aspect-[4/3], aspect-square');
        var $overlay = $('.global-modal-overlay');
        var $content = $('.global-modal-content');
        $modalImage.addClass('custom-image');
        $content.append($modalImage);
        $('body').addClass('overflow-hidden');
        $overlay.show();
        $overlay.focus();
      });
      $(document).on('click', '.global-modal-close, .global-modal-overlay', function (event) {
        if ($(event.target).is('.custom-image')) return;
        $('.global-modal-overlay .custom-image').remove();
        $('.global-modal-overlay').hide();
        $('body').removeClass('overflow-hidden');
      });
      $(document).on('keydown', function (e) {
        if ($('.global-modal-overlay .custom-image').length && e.key === 'Escape') {
          $('.global-modal-overlay .custom-image').remove();
          $('.global-modal-overlay').hide();
          $('body').removeClass('overflow-hidden');
        }
      });
      window.mediaBlockModalBound = true;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
